var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadingBox"},[_c('img',{attrs:{"src":"https://ysb.yundasys.com/file/downloadCenter?k=rkdyaxvqs&n=preloding.png"}})])
}]

export { render, staticRenderFns }